import React from 'react';
import c from 'classnames';
import CheckIcon from '@wix/da-ds/pkg/Icons/16x16/Check';
import DiscordIcon from '@wix/da-ds/pkg/Icons/16x16/Discord';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Flex from '@wix/da-ds/pkg/Flex';

import s from './Benefit.scss';

export interface Props {
  benefit: React.ReactNode;
  isDiscord?: boolean;
  className?: string;
}

const Benefit: React.FC<Props> = ({ benefit, isDiscord, className }) => (
  <Flex className={c(s['root'], className)} alignItems="flex-start">
    {isDiscord ? (
      <DiscordIcon
        className={c(s['icon'], s['icon-discord'])}
        size={IconSize.SMALLER}
        disableDefaultColors
      />
    ) : (
      <CheckIcon
        className={c(s['icon'], s['icon-check'])}
        size={IconSize.SMALLER}
        disableDefaultColors
      />
    )}
    <span>{benefit}</span>
  </Flex>
);
Benefit.displayName = 'Benefit';

export default Benefit;
